import { useReveal } from "../lib/useReveal";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import Gallery from "../components/Gallery";
import Availability from "../components/Availability";
import Testimonials from "../components/Testimonials";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

export default function Home() {
  useReveal();
  return (
    <main className="grain bg-[#050505] text-white" data-testid="home-page">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Gallery />
      <Availability />
      <Testimonials />
      <Contact />
      <Footer />
    </main>
  );
}
